export default __webpack_public_path__ + "static/logo-white-ee07c9ed6227ebbd0d580c8da0bd8296.png";